module.exports = __webpack_public_path__ + "static/media/screen-2.b2fdf540.png";